var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[(_vm.user)?_c('NavBar',{attrs:{"user":_vm.user}}):_vm._e(),(_vm.user)?_c('SideBar',{attrs:{"is-condensed":_vm.isMenuCondensed}}):_vm._e(),_c('div',{staticClass:"content-page"},[_c('div',{},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }